import _ from 'lodash';
    

    var instance = null;

    function TracerouteParser() {
        if (instance !== null) {
            throw new Error('Cannot instanciate more than one TracerouteParser, use TracerouteParser.getInstance()');
        }
    }

    function parseTraceRouteResult(result) {
        if (_.isEmpty(result)) {
            return null;
        }
        return {
            status: _.get(result, 'Status[0].text')
        };
    }

    function parseRountTripTime(rtt) {
        return parseFloat(_.get(rtt, 'text', 0), 10);
    }

    function parseRoute(r) {
        return {
            hop: _.get(r, 'Hop[0].text'),
            roundtriptime: _.chain(r).get('RoundTripTime').map(parseRountTripTime).value(),
            domainname: _.get(r, 'DomainName[0].text'),
            ipaddress: _.get(r, 'IPAddress[0].text'),
            result: parseTraceRouteResult(_.get(r, 'Result[0]'))
        };
    }

    TracerouteParser.prototype = {
        parse: function(rawTraceroute, system) {
            if (_.isEmpty(rawTraceroute) || !_.isArray(rawTraceroute)) {
                return null;
            }
            rawTraceroute = rawTraceroute[0]; // unwrap the traceroute object (it comes as an array of a single traceroute item)

            return {
                source: _.get(system, 'host'),
                target: _.get(rawTraceroute, 'TargetIP[0].text'),
                routes: _.map(rawTraceroute.Routes, parseRoute)
            };
        }
    };

    TracerouteParser.getInstance = function () {
        if (instance === null) {
            instance = new TracerouteParser();
        }
        return instance;
    };

    export default TracerouteParser.getInstance();

